import "../CSS/Ploeg.css";

function U17() {
  return (
    <div className="ploegoverzicht">
      <iframe
        className="klassement"
        src="https://www.voetbalvlaanderen.be/competitie/CHP_129349/rangschikking"
      />
    </div>
  );
}

export default U17;
